<div class="kpi-grid">
  <!-- Revenue KPIs Row -->
  <app-kpi-grid-panel [kpis]="revenueKpis()" titleKey="kpi.section.revenue" icon="pi pi-euro" />

  <!-- Accounts Receivable KPIs Row -->
  <app-kpi-grid-panel [kpis]="accountsReceivableKpis()" titleKey="kpi.section.accountsReceivable" icon="pi pi-euro" />

  <!-- Candidate KPIs Row -->
  <app-kpi-grid-panel [kpis]="candidateKpis()" titleKey="kpi.section.candidates" icon="pi pi-users" />

  <!-- Organization & User KPIs Row -->
  <app-kpi-grid-panel [kpis]="organizationKpis()" titleKey="kpi.section.organizations" icon="pi pi-building" />
</div>
